import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DeliveryService } from '../services/delivery.service';
import { WebErrorService } from '@services/webError.service';

@Component({
  selector: 'app-test-redirection',
  template: ''
})
export class TestRedirectionComponent implements OnInit {
  domain: string;

  constructor(
    private route: ActivatedRoute,
    private deliveryService: DeliveryService,
    private webErrorService: WebErrorService,
    private router: Router,
  ) { this.domain = window.location.hostname }

  ngOnInit(): void {
    const urlSubscription = this.deliveryService.getExamineeLoginTest(this.route.snapshot.paramMap.get('id')).subscribe(data => {
      urlSubscription.unsubscribe();
      if (data && data.redirectUrl) {
        window.location.replace(this.domain === 'dev.tanayassessmentdev' || 'localhost' ? data.redirectUrl.replace('https', 'http') : data.redirectUrl);
      } else { this.router.navigateByUrl('/'); }
    },
    (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }
}
